import React from 'react';

const blogData = [
  {
    title: 'Top Mutual Funds for 2025 You Shouldn’t Miss',
    description: 'Discover the mutual funds that are set to outperform and help you grow your wealth in the coming year.',
    image: '/images/Image (1).png', // Replace with your image path
    link: '#',
  },
  {
    title: 'Why Bond Investments Beat FDs in 2024',
    description: 'Learn why bonds have become a more attractive option compared to traditional fixed deposits.',
    image: '/images/Image (2).png',
    link: '#',
  },
  {
    title: 'Loan Against Mutual Funds: Everything You Need to Know',
    description: 'Understand the benefits and process of taking a loan against your mutual fund investments.',
    image: '/images/Image (3).png',
    link: '#',
  },
];

const BlogHighlights = () => {
  return (
    <div className="blog-container">
      <h2 className="blog-heading">Latest Insights & Blog Highlights</h2>
      <div className="blog-cards">
        {blogData.map((blog, index) => (
          <div className="blog-card" key={index}>
            <img src={blog.image} alt={blog.title} className="blog-image" />
            <h3 className="blog-title">{blog.title}</h3>
            <p className="blog-description">{blog.description}</p>
            <a href={blog.link} className="read-more-button">Read More</a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogHighlights;
